<script lang="ts">
	import type { BlogPagination } from '$models/Blog/BlogPagination';

	let {
		pagination,
		previousLabel,
		nextLabel
	}: {
		pagination: BlogPagination;
		previousLabel: string;
		nextLabel: string;
	} = $props();
</script>

{#snippet chevron()}
	<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 8.91 16">
		<path
			d="m.33,15.67c.45.45,1.17.45,1.62,0l6.45-6.45c.67-.67.67-1.75,0-2.42L1.95.33c-.45-.45-1.17-.45-1.62,0-.45.45-.45,1.17,0,1.62l6.05,6.05L.33,14.05c-.45.45-.45,1.17,0,1.62Z"
			fill="currentColor"
		/>
	</svg>
{/snippet}

{#if pagination.totalPages > 1}
	<nav class="blog-pagination" aria-label="Paginering">
		<ul class="blog-pagination-list">
			<li>
				{#if pagination.prevUrl}
					<a
						class="blog-pagination-arrow blog-pagination-arrow--prev"
						href={pagination.prevUrl}
						rel="prev"
						aria-label={previousLabel}
					>
						{@render chevron()}
					</a>
				{:else}
					<span
						class="blog-pagination-arrow blog-pagination-arrow--prev blog-pagination-arrow--disabled"
						aria-hidden="true"
					>
						{@render chevron()}
					</span>
				{/if}
			</li>
			{#each pagination.pages as page}
				<li>
					<a
						href={page.url}
						class="blog-pagination-link"
						class:is-active={page.isActive}
						aria-current={page.isActive ? 'page' : undefined}
					>
						{page.number}
					</a>
				</li>
			{/each}
			<li>
				{#if pagination.nextUrl}
					<a
						class="blog-pagination-arrow"
						href={pagination.nextUrl}
						rel="next"
						aria-label={nextLabel}
					>
						{@render chevron()}
					</a>
				{:else}
					<span class="blog-pagination-arrow blog-pagination-arrow--disabled" aria-hidden="true">
						{@render chevron()}
					</span>
				{/if}
			</li>
		</ul>
	</nav>
{/if}

<style lang="postcss">
	.blog-pagination {
		margin-top: var(--spacing-10);

		&-list {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 12px;
		}

		&-link,
		&-arrow {
			display: flex;
			align-items: center;
			justify-content: center;
			min-width: 40px;
			height: 40px;
			border-radius: var(--radius-3);
			background-color: var(--color-white);
			color: var(--color-brown);
			border: 1px solid #e0ddd9;
			font-size: 14px;
			line-height: 40px;
			transition:
				color var(--transition),
				border-color var(--transition),
				background-color var(--transition);

			&--prev {
				transform: rotate(180deg);
			}
		}

		&-link {
			&:hover {
				color: var(--color-brown);
				border-color: var(--color-brown);
			}

			&:focus-visible {
				outline: 2px solid var(--color-brown);
				outline-offset: 2px;
			}

			&.is-active {
				color: var(--color-white);
				background: var(--color-brown);
				border-color: var(--color-brown);
			}
		}

		&-arrow {
			font-size: 20px;

			&:hover {
				color: var(--color-brown);
				border-color: var(--color-brown);
			}

			&:focus-visible {
				outline: 2px solid var(--color-brown);
				outline-offset: 2px;
			}

			&--disabled {
				opacity: 0.4;
				pointer-events: none;
			}
		}
	}
</style>
